import React, { useState, useRef, useEffect } from "react";

import { FOREGROUNDCOLOR } from "../../helpers/colors";
import axios from "axios";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import Register from "./Register";
import { CheckConfirm, SendConfirm } from "../../services/AccountService";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Steps } from "primereact/steps";
import { useDispatch } from "react-redux";
import { fetchUserProfile } from "../../features/profile/profileSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { SendConfirmationCode } from "../../services/CommiunicationService";

const CheckPhoneNumber = () => {
  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: Yup.object().shape({
      phoneNumber: Yup.string()
        .required("لطفا شماره تلفن همراه خود را وارد کنید")
        .length(11, "شماره تلفن همراه در فرمت صحیح خود نمیباشد"),
    }),
    onSubmit: (values) => {
      //console.log(values);
      postConfirm(values);
    },
  });

  const userConfirmCodeForm = useFormik({
    initialValues: {
      code: "",
    },
    validationSchema: Yup.object().shape({
      code: Yup.string()
        .required("لطفا کد تایید ارسال شده را وارد کنید")
        .length(5, "کد تایید در فرمت صحیح خود نمیباشد"),
    }),
    onSubmit: (values) => {
      CheckConfirmAsync(values);
    },
  });

  interface MyState {
    index: number;
    invitationCode: any;
  }
  const useOutletContext = <T extends MyState>(): [
    T,
    React.Dispatch<React.SetStateAction<T>>
  ] => {
    const [state, setState] = React.useState<T>({} as T); // Assuming initial state is an empty object

    // Define your logic to set the state, this is just a placeholder
    const setOutletContext = (newState: React.SetStateAction<T>) => {
      setState((prevState) =>
        typeof newState === "function"
          ? newState(prevState)
          : { ...prevState, ...newState }
      );
    };

    return [state, setOutletContext];
  };
  const [activeIndex, setActiveIndex] = useOutletContext();

  const navigate = useNavigate();
  useEffect(() => {});

  const Ref = useRef(null);

  // The state for our timer
  const [timer, setTimer] = useState("00:00");
  const [showTimer, setShowTimer] = useState(false);
  const [getPhoneNumberDisabled, SetPhoneNumberDisabled] = useState(false);
  const getTimeRemaining = (e: any) => {
    const total = Date.parse(e) - Date.parse(new Date().toString());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    if (seconds === 0 && minutes === 0) {
      setShowTimer(false);
      SetPhoneNumberDisabled(false);
    }
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e: any) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      setTimer(
        // (hours > 9 ? hours : "0" + hours) +
        // 	":" +
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    }
  };
  const postConfirm = async (input: any) => {
    try {
      // console.log(input.invitationCode);

      const data = await SendConfirmationCode({
        phoneNumber: input.phoneNumber,
      }).then(function (response: any) {
        // console.log(response);
        if (response.data.statusCode === 400) {
          toast.error(response.data.message);
        } else {
          if (showTimer) return;
          setShowTimer(true);
          SetPhoneNumberDisabled(true);
          clearTimer(getDeadTime());
        }
      });
    } catch (error) {
      // console.log(error);
    }
  };
  const clearTimer = (e: any) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    setTimer("01:00");

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id as any;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 60);
    return deadline;
  };

  // We can use useEffect so that when the component
  // mount the timer will start as soon as possible

  // We put empty array to act as componentDid
  // mount only

  // Another way to call the clearTimer() to start
  // the countdown is via action event from the
  // button first we create function to be called
  // by the button

  const dispatch = useDispatch<any>();

  const CheckConfirmAsync = async (input: any) => {
    try {
      await CheckConfirm(formik.values.phoneNumber, input.code, "0").then(
        (p: any) => {
          // console.log(p);

          if (p.status === 200) {
            //console.log(p.data);

            localStorage.setItem("token", p.data.data.token);
            dispatch(fetchUserProfile()).then(() => {
              setActiveIndex((prevState) => ({
                ...prevState,
                index: 1,
              }));
            });
            navigate("/ForgetPassword/ChangePassword");
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className="mt-2 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 "
        style={{
          height: "400px",
          display: "inline-flex",
        }}
      >
        <div style={{ display: "inline-flex" }}></div>
        <div className="col-12">
          {}
          <div className="mt-5 col-12 px-2">
            <h5 style={{ color: FOREGROUNDCOLOR }}> تغییر کلمه عبور </h5>
          </div>
          <div className="pt-3 col-12 px-2">
            <span className="p-float-label">
              <InputText
                disabled={getPhoneNumberDisabled}
                {...formik.getFieldProps("phoneNumber")}
                id="phoneNumber"
                keyfilter="num"
                style={{ width: "100%" }}
              />
              <label
                style={{ right: "10px", left: "unset" }}
                htmlFor="phoneNumber"
              >
                تلفن همراه
              </label>
              {showTimer ? (
                <span
                  style={{
                    left: "10px",
                    position: "absolute",
                    top: "25%",
                    color: "green",
                    cursor: "pointer",
                  }}
                >
                  {timer}
                </span>
              ) : (
                <Button
                  onClick={formik.submitForm}
                  label="دریافت کد تایید"
                  style={{
                    left: "0px",
                    position: "absolute",
                    top: "0%",
                    borderRadius: "8px 0px 0px 8px",
                    cursor: "pointer",
                  }}
                  className="p-button-success"
                />
              )}

              {/* <span
								onClick={onClickReset}
								style={{
									left: "10px",
									position: "absolute",
									top: "25%",
									color: "green",
									cursor: "pointer",
								}}>
								
							</span> */}
            </span>
            {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
              <b style={{ fontSize: "0.65rem" }} className="my-1 text-danger">
                {formik.errors.phoneNumber}{" "}
              </b>
            ) : null}
          </div>

          <div
            className={`${showTimer ? "" : "d-none"} ${"col-12 mt-4 px-2"}`}
            style={{ width: "100%" }}
          >
            <span className="p-float-label" style={{ width: "100%" }}>
              <InputText
                {...userConfirmCodeForm.getFieldProps("code")}
                id="code"
                keyfilter="num"
                dir="ltr"
                style={{ width: "100%" }}
              />
              <label style={{ right: "10px", left: "unset" }} htmlFor="code">
                کد تایید
              </label>
            </span>
            {userConfirmCodeForm.touched.code &&
            userConfirmCodeForm.errors.code ? (
              <b style={{ fontSize: "0.65rem" }} className="my-1 text-danger">
                {userConfirmCodeForm.errors.code}{" "}
              </b>
            ) : null}
          </div>

          <div
            className={`${showTimer ? "" : "d-none"} ${"col-12 mt-4 px-2"}`}
            style={{ width: "100%" }}
          >
            <Button
              label="ادامه"
              // disabled={showTimer ? false : true}
              style={{ width: "100%" }}
              onClick={userConfirmCodeForm.submitForm}
              className="mt-3 p-button-info"
            ></Button>
          </div>
          {/* <Link to="/Login">
            <div className="col-12 mt-3 px-2" style={{ width: "100%" }}>
              <span style={{ color: "blueviolet" }}> حساب کاربری دارید ؟</span>
              <span style={{ color: "green", cursor: "pointer" }}>
                &nbsp; وارد شوید
              </span>
            </div>
          </Link> */}
        </div>
      </div>
    </>
  );
};
export default CheckPhoneNumber;
